import { GetServerSidePropsContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { ParsedUrlQuery } from "querystring";
import getChannelConfigByPathName from "src/api/channel";
import ContactUsPage from "src/components/icth-product/contact-us/ContactUsPage";
import { withLayout } from "src/components/Layout/withLayout";
import { LOGICAL_GROUP_CHANNEL_CODE } from "src/constants/logicalGroupChannelCode";
import { checkUnknownError } from "src/utils/errors";

const CONTACT_US_META = {
  en: {
    title: "Contact us | Ice Cream Insurance Broker",
    description: "Contact Ice Cream Insurance Broker by phone, email, or LINE.",
  },
  th: {
    title: "ติดต่อเรา | ไอศกรีม โบรคเกอร์ ประกันภัย",
    description:
      "ติดต่อบริษัท ไอศกรีม โบรคเกอร์ ประกันภัย ผ่านโทรศัพท์ อีเมล หรือ LINE",
  },
} as const;

interface CustomParams extends ParsedUrlQuery {
  channelPath: string;
}

export async function getServerSideProps(
  context: GetServerSidePropsContext<CustomParams>
) {
  const channelPath = context.params?.channelPath;
  const locale = context.locale === "en" ? "en" : "th";

  try {
    const channelConfig = await getChannelConfigByPathName(channelPath);

    if (
      !channelConfig ||
      channelConfig.logicalGroupChannelCode !== LOGICAL_GROUP_CHANNEL_CODE
    ) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        channelPath,
        channelConfig,
        systemChannelCode: channelConfig.code,
        isShowAnnouncement: false,
        title: CONTACT_US_META[locale].title,
        description: CONTACT_US_META[locale].description,
        ...(await serverSideTranslations(locale, [
          "common",
          "cookie-consent",
          "layout",
          "contact-us",
        ])),
      },
    };
  } catch (error) {
    const isUnknownError = checkUnknownError(error);

    if (!isUnknownError) {
      return {
        redirect: {
          destination: `/${channelPath}`,
          permanent: false,
        },
      };
    }

    throw error;
  }
}

export default withLayout(ContactUsPage);
